<template>
<div class="modal" ref="modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="mt-0 modal-title">{{ modal_title }}</h5>
                <button class="close text-white" type="button" aria-label="Close" data-dismiss="modal"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">
                <share-form
                    :entities="entities"
                    :edit-share="editShare"
                    :teamSettings="user?.team_settings"
                    @close="hide()"
                />
            </div>
        </div>
    </div>
</div>
</template>
<script lang="js">
/**
 * Displays the share form in a modal dialog, emits 'close' when it was closed.
 * The modal lifecycle is fully contained in this component, e.g. the caller does not have to trigger 'show' and 'hide' events, just 
 * put this component in a 'v-if' that is only true when the modal should be shown.
 * 
 * Set the 'escCloses' prop to False if you don't want the Escape button to close the modal.
 */

import shareForm from '../share-form.vue';
import modalLifecycle from '@/mixins/modal-lifecycle';

export default {

    mixins: [modalLifecycle],

    props: {

        // the logged-in user
        user: Object,

        // File(s) or folder to include in a new share (passed in new share mode)
        entities: {
            type: [Array, null]
        },

        // The existing share that is being edited (passed in share edit mode)
        editShare: { 
            type: [Object, null]
        }
    },

    components: {
        shareForm
    },

    computed: {

        shared_entities(){
            return this.editShare ? this.editShare.entities : this.entities
        },

        modal_title(){
            const what_is_shared = this.shared_entities.length == 1 ? this.shared_entities[0].name : `${this.shared_entities.length} Files`
            return this.editShare ? `Edit Share:  ${what_is_shared}` : `Share ${what_is_shared}`
        }
    },

}

</script>